import React, { useState } from 'react';
import { LOGO_LIGHT, LOGO_DARK } from '../constants';

interface LogoProps {
  variant?: 'light' | 'dark';
  size?: 'normal' | 'large';
  className?: string;
}

export const Logo: React.FC<LogoProps> = ({ variant = 'dark', size = 'normal', className = '' }) => {
  const [imgError, setImgError] = useState(false);
  const src = variant === 'light' ? LOGO_LIGHT : LOGO_DARK;
  const height = size === 'large' ? 'h-14 md:h-20' : 'h-14 md:h-20';

  if (imgError) {
    return (
      <span
        className={`font-black ${height} flex items-center ${className}`}
        style={{
          color: '#087064',
          fontSize: size === 'large' ? '1.75rem' : '1.125rem',
        }}
      >
        ANCORA
      </span>
    );
  }

  return (
    <img
      src={src}
      alt="ANCORA Automations"
      className={`${height} w-auto object-contain ${className}`}
      onError={() => setImgError(true)}
    />
  );
};